import dynamic from 'next/dynamic';

const EmbedComponent = dynamic(() => import(`./Embed`));

const components = {
    AUDIO: dynamic(() => import(`./Audio`)),
    CITA: dynamic(() => import(`./Cites`)),
    IMATGE: dynamic(() => import(`./ImatgeCos`)),
    IMATGE_RELACIONADA: dynamic(() => import(`./ImatgeCos`)),
    LINK: dynamic(() => import(`components/3catinfo/Enllac`)),
    DESTACAT_RELACIONAT: dynamic(() => import(`./DestacatRelacionat`)),
    NOTICIA_RELACIONADA: dynamic(() => import(`./NoticiaRelacionada`)),
    TEXT: dynamic(() => import(`./Text`)),
    VIDEO: dynamic(() => import(`./Video`)),
    VIDEO_ANIMAT: dynamic(() => import(`./VideoAnimat`)),
    BLUESKY: EmbedComponent,
    CARTO: EmbedComponent,
    DATAWRAPPER: EmbedComponent,
    FACEBOOK: EmbedComponent,
    FLOURISH: EmbedComponent,
    IFRAME_3CAT: EmbedComponent,
    INFOGRAM: EmbedComponent,
    INSTAGRAM: EmbedComponent,
    QUALIFIO: EmbedComponent,
    OPTA: EmbedComponent,
    TIKTOK: EmbedComponent,
    TWITTER: EmbedComponent,
    YOUTUBE: EmbedComponent,
    VIMEO: EmbedComponent
};

export { components };
